import css from 'styled-jsx/css';
import uuid from 'uuid';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import startOfDay from 'date-fns/startOfDay';
import subYears from 'date-fns/subYears';

import Form from '../../../common/forms/Form';
import FormControl from '../../../common/elements/FormControl';
import CountrySelector from '../../../common/elements/CountrySelector';
import { strings, dates, validate } from '../../../common/forms/Validations';
import Button from '../../../common/elements/Button';
import DateControl from '../../../common/forms/DateControl';
import { dimensions } from '../../../common/Theme';

const DESKTOP_BREAKPOINT = 600;
const FORMCONTROL_PADDING = 9;
const styles = css`
  .form {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
  .form-control {
    display: flex;
    flex-direction: column;
  }

  @media (min-width: ${DESKTOP_BREAKPOINT}px) {
    .form-control {
      width: 50%;
      box-sizing: border-box;
    }
    .form-control:nth-child(odd) {
      padding-right: ${FORMCONTROL_PADDING}px;
    }
    .form-control:nth-child(even) {
      padding-left: ${FORMCONTROL_PADDING}px;
    }
    .form {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
`;
const embeddedStyles = css.resolve`
  .add {
    width: 25%;
    min-width: 200px;
    align-self: center;
  }
  .birthday {
    margin: 0;
    min-height: 52px;
    font-size: 0.7rem;
    line-height: 1.4;
    box-sizing: border-box;
  }
  .country {
    margin-bottom: ${dimensions.ywgFormSpacing};
  }
  @media (min-width: ${DESKTOP_BREAKPOINT}px) {
    .form-control:nth-child(odd) {
      padding-right: ${FORMCONTROL_PADDING}px;
    }
    .form-control:nth-child(even) {
      padding-left: ${FORMCONTROL_PADDING}px;
    }
    .country {
      width: 50%;
      box-sizing: border-box;
    }
  }
`;

const validator = () => {
  const today = startOfDay(new Date());
  const limit = startOfDay(subYears(new Date(), 64));
  return {
    firstname: [strings.required.withError('')],
    lastname: [strings.required.withError('')],
    birthday: [
      strings.required.withError(''),
      dates
        .isBefore(today)
        .withError(
          `Notre contrat ne permet pas encore d'assurer les enfants avant leur naissance, mais nous serions ravis d'échanger sur votre besoin: contact@yupwego.com`
        ),
      dates
        .isAfter(limit)
        .withError(
          "L'offre YUPWEGO n'est pas encore disponible au delà de 64 ans, mais nous y travaillons. Contactez-nous et nous chercherons une solution ensemble, contact@yupwego.com."
        )
    ],
    country: [strings.required.withError('')]
  };
};

const NewTraveler = ({ countries, onAdd }) => {
  const key = uuid.v1();
  const traveler = {
    firstname: '',
    lastname: '',
    birthday: '',
    country: '',
    key
  };
  return (
    <>
      <Form
        key={key}
        initialValues={traveler}
        validate={value => validate(value, validator(countries))}
        onSubmit={onAdd}
      >
        {({ values, metas, onChange, onBlur, doSubmit }) => (
          <form onSubmit={doSubmit} className="form">
            <div className="form-control">
              <FormControl
                label="PRÉNOM"
                name="firstname"
                value={values.firstname}
                valid={metas.firstname.valid}
                error={metas.firstname.error}
                onChange={onChange}
                onBlur={onBlur}
                required
                autoFocus
              />
            </div>
            <div className="form-control">
              <FormControl
                label="NOM"
                name="lastname"
                value={values.lastname}
                valid={metas.lastname.valid}
                error={metas.lastname.error}
                onChange={onChange}
                onBlur={onBlur}
                required
              />
            </div>
            <div className="form-control">
              <DateControl
                label="DATE DE NAISSANCE"
                className={classnames('birthday', embeddedStyles.className)}
                name="birthday"
                value={values.birthday}
                onChange={onChange}
                onBlur={onBlur}
                error={metas.birthday}
                valid={metas.birthday.valid}
                required
              />
            </div>
            <CountrySelector
              label="PAYS DE RÉSIDENCE"
              name="country"
              countries={countries}
              className={classnames(
                'country',
                'form-control',
                embeddedStyles.className
              )}
              value={values.country}
              valid={metas.country.valid}
              error={metas.country.error}
              onChange={onChange}
              onBlur={onBlur}
              required
            />
            <Button
              className={classnames('add', embeddedStyles.className)}
              type="submit"
              shadowed
            >
              Ajouter
            </Button>
          </form>
        )}
      </Form>
      <style jsx>{styles}</style>
      {embeddedStyles.styles}
    </>
  );
};

NewTraveler.propTypes = {
  countries: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired
};

export default NewTraveler;
